<template lang="pug">
fragment
  dt(style="background-color: cornsilk;")
    | 事前アンケート
  dd(style="background-color: cornsilk;")
    | 映像編集についてお答えください
  dt.required
    | RAW動画の収録経験はありますか？
  dd
    div
      validation-provider(rules="required" name="RAW動画の収録経験" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .v-radio(v-for="(yn, i) in yesNo" :key="i")
            input(type="radio" v-model="enquete.raw_video_recording_experience" :value="yn" :id="`rawVideoRecordingExperience-${i}`")
            label(:for="`rawVideoRecordingExperience-${i}`")
              | {{ yn }}
  dt.required
    | RAW動画の編集経験はありますか？
  dd
    div
      validation-provider(rules="required" name="RAW動画の編集経験" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .v-radio(v-for="(yn, i) in yesNo" :key="i")
            input(type="radio" v-model="enquete.raw_video_editing_experience" :value="yn" :id="`rawVideoEditingExperience-${i}`")
            label(:for="`rawVideoEditingExperience-${i}`")
              | {{ yn }}
  dt.required
    | 最も使用頻度の高い映像編集ソフトを1つ選択してください。
  dd
    div
      validation-provider(rules="required" name="通常使用している編集ソフト" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .v-radio(v-for="(soft, i) in softs" :key="i")
            input(type="radio" v-model="enquete.editing_software_you_use" :value="soft" :id="`editingSoftwareYouUse-${i}`")
            label(:for="`editingSoftwareYouUse-${i}`")
              | {{ soft }}
            template(v-if="soft === 'その他'")
              validation-provider(:rules="{ required: isOtherRequired(`editingSoftwareYouUse-${i}`) }" name="その他のソフト" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
                .error-message(v-if="errors[0]" v-html="errors[0]")
                input(type="text" v-model="enquete.editing_software_you_use_other" :class="{ error: invalid && validated }")

  dt.required
    | 通常使用しているカメラを1つ選択してください。
  dd
    div
      validation-provider(rules="required" name="通常使用しているカメラ" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .v-radio(v-for="(camera, i) in cameras" :key="i")
            input(type="radio" v-model="enquete.camera_you_are_using" :value="camera" :id="`cameraYouAreUsing-${i}`")
            label(:for="`cameraYouAreUsing-${i}`")
              | {{ camera }}
            template(v-if="camera === 'その他'")
              validation-provider(:rules="{ required: isOtherRequired(`cameraYouAreUsing-${i}`) }" name="その他のカメラ" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
                .error-message(v-if="errors[0]" v-html="errors[0]")
                input(type="text" v-model="enquete.camera_you_are_using_other" :class="{ error: invalid && validated }")

  dt.required
    | あなたの制作スタイルを1つ選択してください。
  dd
    div
      validation-provider(rules="required" name="制作スタイル" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .v-radio(v-for="(style, i) in styles" :key="i")
            input(type="radio" v-model="enquete.video_production_style" :value="style" :id="`videoProductionStyle-${i}`")
            label(:for="`videoProductionStyle-${i}`")
              | {{ style }}
            template(v-if="style === 'その他'")
              validation-provider(:rules="{ required: isOtherRequired(`videoProductionStyle-${i}`) }" name="その他の制作スタイル" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
                .error-message(v-if="errors[0]" v-html="errors[0]")
                input(type="text" v-model="enquete.video_production_style_other" :class="{ error: invalid && validated }")

  dt.optional
    | 今回のウェビナーで特に重点的に学びたい項目を1つお選びください。
  dd
    div
      validation-provider(rules="" name="学びたい項目" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .v-radio(v-for="(learn, i) in learns" :key="i")
            input(type="radio" v-model="enquete.want_to_learn" :value="learn" :id="`want_to_learn-${i}`")
            label(:for="`want_to_learn-${i}`")
              | {{ learn }}
</template>

<script>
import { Fragment } from 'vue-fragment'
import FormTextInput from '~/components/FormTextInput'
import FormTextarea from '~/components/FormTextarea'

const YES_NO = ['はい', 'いいえ']
const SOFTS = [
  'Adobe Premiere Pro',
  'Adobe Premiere Elements',
  'Adobe Premiere Rush',
  'Adobe After Effects',
  'AviUtl',
  'DaVinci Resolve',
  'Final Cut Pro',
  'Filmora',
  'iMovie',
  'NX Studio',
  'その他'
]
const CAMERAS = [
  'Nikon Z 9、Z 8',
  'Nikon Z 7II,Z 6II,Z 7,Z 6',
  'Nikon Z 30 , Z fc',
  'その他のNikon Zシリーズ',
  'Nikon 一眼レフカメラ  ',
  'COOLPIX シリーズ',
  'パナソニック LUMIX Gシリーズ',
  'パナソニック LUMIX Sシリーズ',
  'その他のパナソニックのカメラ',
  'ソニー αシリーズ',
  'ソニー FXシリーズ',
  'その他のソニーのカメラ',
  'キヤノン EOSシリーズ',
  'その他のキヤノンDSLR／ミラーレスカメラ',
  'フジフイルム GFX シリーズ',
  'フジフイルム X-H シリーズ',
  'フジフイルム X-T シリーズ',
  'その他のフジフイルムのカメラ',
  'ブラックマジックデザイン Blackmagic Pocket Cinema Camera 6K Pro',
  'ブラックマジックデザイン Blackmagic Pocket Cinema Camera 6K',
  'ブラックマジックデザイン Blackmagic Pocket Cinema Camera 4K',
  'その他のブラックマジックデザインのカメラ',
  'RED KOMODO 4K／6K',
  'ARRI ALEXA Mini',
  'その他'
]
const STYLES = [
  'ビデオグラファー',
  'カメラマン（フォト）',
  'カメラマン（ビデオ）',
  'シネマトグラファー',
  'ディレクター',
  'エディター',
  'カラリスト',
  'プロデューサー',
  'CGデザイナー',
  'YouTuber',
  'その他'
]
const LEARNS = [
  'RAWとは',
  '井上さんが日頃使用してるカメラやワークフロー',
  'RAW動画の編集・カラーグレーティングのワークフロー ',
  'RAWデータのカラーグレーディング実践'
]

export default {
  components: {
    FormTextInput,
    FormTextarea,
    Fragment
  },
  data() {
    return {
      enquete: {
        raw_video_recording_experience: null,
        raw_video_editing_experience: null,
        editing_software_you_use: null,
        editing_software_you_use_other: null,
        camera_you_are_using: null,
        camera_you_are_using_other: null,
        video_production_style: null,
        video_production_style_other: null,
        want_to_learn: null
      }
    }
  },
  computed: {
    yesNo() {
      return YES_NO
    },
    softs() {
      return SOFTS
    },
    cameras() {
      return CAMERAS
    },
    styles() {
      return STYLES
    },
    learns() {
      return LEARNS
    }
  },
  watch: {
    'enquete.raw_video_recording_experience': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.raw_video_editing_experience': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.editing_software_you_use': {
      handler() {
        if (this.enquete.editing_software_you_use !== 'その他') {
          this.enquete.editing_software_you_use_other = null
        }
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.editing_software_you_use_other': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.camera_you_are_using': {
      handler() {
        if (this.enquete.camera_you_are_using !== 'その他') {
          this.enquete.camera_you_are_using_other = null
        }
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.camera_you_are_using_other': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.video_production_style': {
      handler() {
        if (this.enquete.video_production_style !== 'その他') {
          this.enquete.video_production_style_other = null
        }
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.video_production_style_other': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.want_to_learn': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    }
  },
  mounted() {
    const enqueteCookie = this.$cookies.get('entryEventEnquete')
    if (enqueteCookie) {
      this.enquete = enqueteCookie
    }
  },
  methods: {
    isOtherRequired(id) {
      if (process.browser) {
        const element = document.getElementById(id)
        if (element) {
          return element.checked
        }
      } else {
        return false
      }
    }
  }
}
</script>
